import { useState } from 'react';
import { AgentsSection } from 'features/chat/components/agents-section';
import { AgentSummary } from 'features/chat/agent-chat-module/types/agent.service.type';
import { ProjectsSection } from 'features/projects/components/project-section';
import { AgentGroupBy, readAgentGroupBy, storeAgentGroupBy } from './agents-group-menu';

type SidebarGroupedSectionsProps = {
  agents?: AgentSummary[];
  chatId?: string;
  onGroupByChange?: (groupBy: AgentGroupBy) => void;
  fill?: boolean;
};

export function SidebarGroupedSections({
  agents,
  chatId,
  onGroupByChange,
  fill = false,
}: SidebarGroupedSectionsProps) {
  const [groupBy, setGroupBy] = useState<AgentGroupBy>(readAgentGroupBy);

  const handleGroupByChange = (next: AgentGroupBy) => {
    setGroupBy(next);
    storeAgentGroupBy(next);
    onGroupByChange?.(next);
  };

  if (groupBy === 'projects') {
    return <ProjectsSection groupBy={groupBy} onGroupByChange={handleGroupByChange} />;
  }

  return (
    <AgentsSection
      agents={agents}
      chatId={chatId}
      groupBy={groupBy}
      onGroupByChange={handleGroupByChange}
      fill={fill}
    />
  );
}
